import React from 'react';
import { Col, Form, Input, Row } from 'antd';
import PropTypes from 'prop-types';

// eslint-disable-next-line no-unused-vars
const UAFLegalPersonForm = ({ gutter }) => (
  <>
    <Row justify="start" gutter={[gutter]}>
      <Col className="declaringPersonForm__title" span={24}>
        Persona jurídica declarante
      </Col>
    </Row>
    <Row gutter={[gutter]}>
      <Col lg={12} xs={24}>
        <Form.Item label="RUT" name={['legalPerson', 'rut']}>
          <Input disabled />
        </Form.Item>
      </Col>
      <Col lg={12} xs={24}>
        <Form.Item label="Nombre o Razón Social" name={['legalPerson', 'name']}>
          <Input disabled />
        </Form.Item>
      </Col>
    </Row>
    <Row gutter={[gutter]}>
      <Col lg={12} xs={24}>
        <Form.Item label="País" name={['legalPerson', 'commercialAddress', 'country']}>
          <Input disabled />
        </Form.Item>
      </Col>
      <Col lg={12} xs={24}>
        <Form.Item label="Región" name={['legalPerson', 'commercialAddress', 'region']}>
          <Input disabled />
        </Form.Item>
      </Col>
    </Row>
    <Row gutter={[gutter]}>
      <Col lg={12} xs={24}>
        <Form.Item label="Comuna" name={['legalPerson', 'commercialAddress', 'city']}>
          <Input disabled />
        </Form.Item>
      </Col>
      <Col lg={12} xs={24}>
        <Form.Item label="Calle/Avenida" name={['legalPerson', 'commercialAddress', 'streetName']}>
          <Input disabled />
        </Form.Item>
      </Col>
    </Row>
    <Row gutter={[gutter]}>
      <Col lg={6} xs={24}>
        <Form.Item label="Número" name={['legalPerson', 'commercialAddress', 'streetNumber']}>
          <Input disabled />
        </Form.Item>
      </Col>
      <Col lg={6} xs={24}>
        <Form.Item label="Depto/Casa" name={['legalPerson', 'commercialAddress', 'houseNumber']}>
          <Input disabled />
        </Form.Item>
      </Col>
    </Row>
  </>
);

UAFLegalPersonForm.propTypes = {
  gutter: PropTypes.number.isRequired,
};

export default UAFLegalPersonForm;
